(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["couples-about-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function countUp(el) {
      var raw = el.getAttribute('data-cpa-count') || '';
      if (!/^\d+$/.test(raw)) return;
      var end = parseInt(raw, 10), dur = 1400, start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      el.textContent = '0';
      requestAnimationFrame(step);
    }

    function reveal(node) {
      node.classList.add('is-in');
      node.querySelectorAll('[data-cpa-count]').forEach(function (n) { if (!reduce) countUp(n); });
    }

    function init(root) {
      if (root.getAttribute('data-cpa-ready')) return;
      root.setAttribute('data-cpa-ready', '1');
      var items = root.querySelectorAll('[data-cpa-reveal]');
      var inEditor = window.Shopify && window.Shopify.designMode;
      if (!('IntersectionObserver' in window) || inEditor) {
        items.forEach(function (n) { n.classList.add('is-in'); });
        return;
      }
      root.classList.add('cpa--js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      items.forEach(function (n) { io.observe(n); });
    }

    function initAll(ctx) {
      (ctx || document).querySelectorAll('[data-cpa]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
